import { Button } from 'react-bootstrap';
import Table from '../Components/Tables/Table';
import { addLineItem } from '../Data/testData';
import { useStore } from '../store/Store';

type addLineLayoutProps = {
    handleClose?: ()=> void;
    handleAddItem?: (selectedRows: any[])=> void;
}
const AddLineLayout: React.FC<addLineLayoutProps> = ({handleClose, handleAddItem}) => {
    let data: any;
    const setSelectedItem = useStore((state) => state.setSelectedItem);
    const selectedItem = useStore((state) => state.selectedItem);
    const handelSelectRows = (selectedRow: Set<number>) => {
        data = Array.from(selectedRow).map(index => addLineItem[index]);
    };

    const handleAddLineItem = () => {
        if(selectedItem){
            // @temp: Auto increase the line number based on the length of the selectedItem array
            // @observation: This is not correctly implemented, as the line number should be unique
            // with respect to the all items present in the table
            let lastLength = selectedItem.length;
            data.forEach((item: { Line: string; }) => {
                lastLength++;
                item.Line = (lastLength).toString();
            });
            setSelectedItem([...selectedItem, ...data]);
        }
        else{
            setSelectedItem(data);
        }
        handleAddItem && handleAddItem(data);
        handleClose && handleClose();
        
    }


    const columns = [{
        name: 'Item Code',
        selector: (row: { imgSrc: string; ItemCode: string }) => (

            row.imgSrc && (
                <div className = "d-flex">
                    <img
                        src={require(`../assets/images/${row.imgSrc}`)}
                        style={{ width: "40px", marginRight: "2px" }}
                    />
                    <p className='mt-2'>
                        {row.ItemCode}
                    </p>

                </div>
            )
        )
    },
    {
        name: 'Item Name',
        selector: (row: { ItemName: string }) => <p className="mt-2">{row.ItemName}</p>
    },
    {
        name: 'UOM',
        selector: (row: { UOM: string }) => <p className="mt-2">{row.UOM}</p>
    },
    {
        name: 'Qty on Hand',
        selector: (row: { quantityOnHand: string }) => <p className="mt-2">{row.quantityOnHand}</p>
    },
    ]

    return (

        <>
            <div className="count-expanded-view-list ">
            <Table columns={columns} data={addLineItem} enableGlobalSearching={true} onSelectedRowsChange={handelSelectRows} />

            </div>
            <div className="d-flex justify-content-end">
                <Button className="sph-btn sph-shift me-2" onClick={handleClose}>Cancel</Button>
                <Button className="sph-btn ms-2" onClick={handleAddLineItem}>Add</Button>
            </div>
        </>
    )
}

export default AddLineLayout